import React from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";

const ReactMarkdown = React.lazy(() => import("react-markdown"));

export default function PartnerRegistrationConditions() {
	const { t } = useTranslation("registration");

	return (
		<div className="form__group">
			<div className="label u-type--base u-type--wgt--medium u-color--text--primary">
				{t("TERMS_CONDITIONS_LABEL")}
				<RequiredMark required />
			</div>

			<CheckboxInput
				id="termsAndPrivacyCheckbox"
				name="acceptTermsAndConditions"
			/>
		</div>
	);
}

function CheckboxInput(props: { id: string; name: string }) {
	const { name, id } = props;

	const { t } = useTranslation("registration");
	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: true,
			message: "COMMON.REQUIRED_FIELD",
		},
	});

	return (
		<div>
			<ErrorMessage name={name} />

			<div className="input--check input--check--sml">
				<input
					id={id}
					className="input--check__box input--check--sml__box"
					type="checkbox"
					{...field}
				/>
				<label
					htmlFor={id}
					className="input--check__label input--check--sml__label"
				>
					<ReactMarkdown
						linkTarget={"_blank"}
						className="u-anchor--nested"
					>
						{t("TERMS_CONDITIONS")}
					</ReactMarkdown>
				</label>
			</div>
		</div>
	);
}
